import { DataService } from '../../utils/dataService'
import { error, message } from '../../notifications/displayMessage'
import { AxiosResponse } from 'axios'
import { datadogLogs } from '@datadog/browser-logs'
import { language } from '../../utils/language'

export const LOAD_DATA_PRODUCT = 'LOAD_DATA_PRODUCT'
export const LOAD_DATA_PRODUCT_INFO = 'LOAD_DATA_PRODUCT_INFO'
export const TOGGLE_LOADING_DATA_PRODUCT = 'TOGGLE_LOADING_DATA_PRODUCT'
export const DEFAULT_DATA_PRODUCT = 'DEFAULT_DATA_PRODUCT'
export const REDIRECT_NOT_FOUND = 'REDIRECT_NOT_FOUND'
export const SET_RELATED_PRODUCT = 'SET_RELATED_PRODUCT'



export const callDataProduct = (path: string) => async(dispatch: any) => {
  const _dataService = new DataService()
  const url = { url: path }
  await _dataService
    .postElastic('/catalogue/topsellingproducts', url)
    .then((res: AxiosResponse) => {
      if (res.status === 200) {
        if (res.data.success) {
          dispatch({
            type: LOAD_DATA_PRODUCT,
            payload: res.data
          })
        } else if (res.data.cod_error === 404) {
          window.location.replace('/errors/error-404')
        } else if (!res.data.success) {
          return error('Ha ocurrido un error')
        }
      }
    })
    .catch((err) => {
      error(`Ha ocurrido un error `)
      datadogLogs.logger.info('error request callDataProduct', { name: 'post /catalogue/topsellingproducts', body: url, error: err.message })
    })
}

export const callDataProductInfo = (path: string, productId: any, manage: number = 0, defaultLanguage: string) => async(dispatch: any) => {
  const _dataService = new DataService()

  const filter = { name: "id", value: productId, manage }
  dispatch(toggleLoadingProduct(true))
  await _dataService
    .postElastic('/catalogue/products', filter)
    .then((res: AxiosResponse) => {
      
      if (res.status === 200) {
        if (res.data.success) {
          
          if(manage === 1 || (res.data.data[0].edataStatus ==='Permitido')){
            
            if (res.data.data.length > 0) {
              dispatch({
                type: LOAD_DATA_PRODUCT_INFO,
                payload: res.data.data[0]
              })
              dispatch(toggleLoadingProduct(false))
            } else {
              dispatch(toggleRedirectNotFound(true));
              dispatch(toggleLoadingProduct(false));
              
            }
          }else{
            dispatch(toggleLoadingProduct(false))
            return message(language[defaultLanguage]["catalogueInactive"])            
          }
        } else if (res.data.cod_error === 404) {
          window.location.replace('/errors/error-404')
          dispatch(toggleLoadingProduct(false))
        } else if (!res.data.success) {
          dispatch(toggleLoadingProduct(false))
          return error('Ha ocurrido un error')          
        }
      }
    })
    .catch((err) => {
      // error('Ha ocurrido un error'); 
      // redirect to 404
      dispatch(toggleRedirectNotFound(true));
      dispatch(toggleLoadingProduct(false))
      datadogLogs.logger.info('error request callDataProductInfo', { name: 'post /catalogue/products', body: filter, error: err.message })
    })
}

export const callCategoryProduct = (path: string, categorieId: any) => async(dispatch: any) => {
  const _dataService = new DataService()
  const filter = { name: "categorieId", value:categorieId }
  // const filter = { url: path, filter: { name: "categorieId", value:categorieId } }
  await _dataService
    .postElastic('/catalogue/products', filter)
    .then((res: AxiosResponse) => {
      
      if (res.status === 200) {
        if (res.data.success) {
          dispatch({
            type: LOAD_DATA_PRODUCT,
            payload: res.data
          })
        } else if (res.data.cod_error === 404) {
          window.location.replace('/errors/error-404')
        } else if (!res.data.success) {
          return error('Ha ocurrido un error')
        }
      }
    })
    .catch((err) => {
      error(`Ha ocurrido un error `)
      datadogLogs.logger.info('error request callCategoryProduct', { name: 'post /catalogue/products', body: filter, error: err.message })
    })
    
}

export const toggleLoadingProduct = (loading: boolean) => async(dispatch: any) => {
  
  dispatch({
    type: TOGGLE_LOADING_DATA_PRODUCT,
    payload: loading
  })
}

export const toggleRedirectNotFound = (res: boolean) => async(dispatch: any) => {
  dispatch({
    type: REDIRECT_NOT_FOUND,
    payload: res
  })
}

export const defaultDataProduct = () => async(dispatch: any) => {
  dispatch({
    type: DEFAULT_DATA_PRODUCT
  })
}

export const setRelatedProducts = (res: any) => async(dispatch: any) => {
  dispatch({
    type: SET_RELATED_PRODUCT,
    payload: res
  })
}
